<template>
    <div>
      <Pos_invoice_Receipt_58mm/>
    </div>
  </template>
  
  <script>
  import Pos_invoice_Receipt_58mm from "@/components/adminArin/pos_system/pos/Pos_invoice_Receipt_58mm";
  export default {
    name: "PosInvoiceReceiptFull",
    components: {
      Pos_invoice_Receipt_58mm
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  